import { IValidatorFactoryService } from './validator-factory.service';
import { IDuplicatesMetadata } from 'app/extensibility/metadatas/validator/duplicates-metadata';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';


export class DuplicatesValidatorFactoryService implements IValidatorFactoryService<IDuplicatesMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'duplicates';

    public createValidatorByMetadata(metadata: IDuplicatesMetadata): IValidatorFn {
        return this.createValidator(metadata.referencesToCheck, metadata.isDuplicateCondition, metadata.errorMessage);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public createValidator(referencesToCheck: any[] = [], isDuplicateCondition?: (a: any, b: any) => boolean, errMsg?: string, excludeTarget?: boolean): IValidatorFn {
        const errorMessage = errMsg || stringResources.Validator_Short_ErrorMessage_Unique_Name;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (object: any) => {
            isDuplicateCondition = isDuplicateCondition || this._defaultDuplicateCondition;
            return referencesToCheck.filter((r) => isDuplicateCondition(r, object)).length > (excludeTarget ? 0 : 1) ? errorMessage : null;
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private readonly _defaultDuplicateCondition = (a: any, b: any) => a === b;
}
